import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["image", "name", "children"];
import { PullQuote as Base } from "@cancer-council-queensland/react";
import { render } from "storyblok-rich-text-react-renderer";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PullQuote = _ref => {
  var {
    image,
    name,
    children
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_jsxs(Base, _extends({}, rest, {
    children: [image && image != null && image.filename ? /*#__PURE__*/_jsx(Base.Image, {
      src: image.filename,
      alt: image.alt
    }) : null, /*#__PURE__*/_jsx(Base.Content, {
      name: name,
      children: render(children)
    })]
  }));
};
//# sourceMappingURL=pull_quote.js.map